<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">AMRO Times</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Workshop, publication, web-to-print</p>
        <p>AMRO Times was an exercise to build a collective memory of the <a href="https://art-meets.radical-openness.org/">AMRO22</a> festival and feed-forward it in a printed form into the networks of networks surrounding AMRO. The work session introduced a networked workflow based on pads, RSS feeds and web-to-print techniques.</p>
        <p>This networked documentation layer of the AMRO festival was a collaboration between <a href="https://habitattt.it/">Habitat</a> and <a href="https://varia.zone">Varia</a>. Photos by Eva Maria Dreisiebner and Sabiwabis Sabina Piñero.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/amrotimes/times1.jpg"></b-img>


      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/amrotimes/times3.jpg"></b-img>
        <p></p>



      </b-col>

        <b-col md="4" offset-md="4">
          <b-img class="img-fluid" src="media/amrotimes/times2.jpg"></b-img>
          <p></p>



        </b-col>
    </b-row>


  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'AmroTimes',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
